// Module
var code = `<div class="helpvalue schema-form-helpvalue {{form.htmlClass}}" ng-bind-html="form.helpvalue"></div>
`;
// Exports
module.exports = code;